import { NothingFound } from "./NothingFound";

export default NothingFound;
